module.exports = __webpack_public_path__ + "img/image11.e23ae08.webp";